import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const insights = [
  {
    id: 1,
    title: 'Spending Pattern Detected',
    description: 'Your dining expenses spike 40% on weekends. Setting a weekly dining limit of $70 could save you $120/month.',
    category: 'Behavior',
    icon: 'Brain',
    color: '#7C3AED',
    bg: 'rgba(124,58,237,0.1)',
    impact: 'Save $120/mo',
    impactColor: '#10B981',
    confidence: 94,
  },
  {
    id: 2,
    title: 'Subscription Audit',
    description: 'You have 6 active subscriptions totaling $87.94/month. 2 haven\'t been used in 30+ days.',
    category: 'Optimization',
    icon: 'RefreshCw',
    color: '#06B6D4',
    bg: 'rgba(6,182,212,0.1)',
    impact: 'Save $31.98/mo',
    impactColor: '#10B981',
    confidence: 98,
  },
  {
    id: 3,
    title: 'Vacation Goal on Track',
    description: 'At your current savings rate, you\'ll reach your $5,000 vacation goal by July 2026 — one month ahead of schedule!',
    category: 'Goals',
    icon: 'TrendingUp',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.1)',
    impact: '1 month early',
    impactColor: '#06B6D4',
    confidence: 87,
  },
];

export default function MLInsights() {
  const [dismissed, setDismissed] = useState([]);
  const visible = insights?.filter(i => !dismissed?.includes(i?.id));

  return (
    <div className="bg-[#0F172A] border border-[rgba(6,182,212,0.1)] rounded-xl p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-5">
        <div className="w-8 h-8 rounded-lg bg-[rgba(124,58,237,0.15)] flex items-center justify-center">
          <Icon name="Sparkles" size={16} color="#A78BFA" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg text-[#F8FAFC]">AI Insights</h3>
          <p className="text-xs text-[#94A3B8]">Personalized recommendations</p>
        </div>
      </div>
      {visible?.length === 0 ? (
        <div className="text-center py-6">
          <Icon name="CheckCircle" size={32} color="#10B981" className="mx-auto mb-2" />
          <p className="text-sm text-[#94A3B8]">All insights reviewed!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {visible?.map((insight) => (
            <div
              key={insight?.id}
              className="border border-[rgba(6,182,212,0.08)] rounded-lg p-4 hover:border-[rgba(6,182,212,0.15)] transition-all duration-250"
              style={{ backgroundColor: insight?.bg }}
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${insight?.color}20` }}>
                  <Icon name={insight?.icon} size={18} color={insight?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <p className="font-heading font-semibold text-sm text-[#F8FAFC]">{insight?.title}</p>
                    <button
                      onClick={() => setDismissed(p => [...p, insight?.id])}
                      className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-[rgba(255,255,255,0.08)] transition-all flex-shrink-0"
                      aria-label="Dismiss insight"
                    >
                      <Icon name="X" size={12} color="#94A3B8" />
                    </button>
                  </div>
                  <p className="text-xs text-[#CBD5E1] leading-relaxed mb-2">{insight?.description}</p>
                  <div className="flex items-center gap-3">
                    <span className="text-xs font-semibold" style={{ color: insight?.impactColor }}>
                      {insight?.impact}
                    </span>
                    <span className="text-xs text-[#475569]">·</span>
                    <span className="text-xs text-[#94A3B8]">
                      <span className="font-data" style={{ color: insight?.color }}>{insight?.confidence}%</span> confidence
                    </span>
                    <span className="text-xs bg-[rgba(6,182,212,0.08)] text-[#06B6D4] px-2 py-0.5 rounded-full">{insight?.category}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}